export default __webpack_public_path__ + "static/media/Tunsus.55d87ae1.jpg";